export const WHITE = '#FFFFFF';
export const BLACK = '#000000';

export const LIGHT_SOY = '#BABCC1';
export const MEDIUM_SOY = '#696970';
export const SOY = '#30323B';

export const PEACH = '#ffdbcf';
export const PLUM = '#84565e';
export const LIGHT_SALMON = '#FFD2C9';

export const MEDIUM_TOFU = '#E5E5E6';
export const TOFU = '#f5f5f6';

export const AVAILABLE_STATUS_BLUE = '#1976D2';

export const DEFAULT_PRIMARY_COLOR = MEDIUM_SOY;

export const BLUE = '#1976D2';

export const TOMATO = '#F15541';

export const ERROR = '#c7254e';

declare module '@mui/material/styles' {
  interface Palette {
    soy: Palette['primary'];
    tofu: Palette['primary'];
  }

  interface PaletteOptions {
    soy: PaletteOptions['primary'];
    tofu: Palette['primary'];
  }
}

export const createPalette = (primaryColor = DEFAULT_PRIMARY_COLOR) => ({
  blue: BLUE,
  primary: { main: primaryColor },
  salmon: { light: LIGHT_SALMON },
  soy: {
    light: LIGHT_SOY,
    main: MEDIUM_SOY,
    dark: SOY
  },
  tofu: {
    light: WHITE,
    main: TOFU,
    dark: MEDIUM_TOFU,
    contrastText: BLACK
  },
  tomato: TOMATO
});
